import { render } from "./ListeAvisTalentPage.vue?vue&type=template&id=6677cd36&ts=true"
import script from "./ListeAvisTalentPage.vue?vue&type=script&lang=ts"
export * from "./ListeAvisTalentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__